module.exports = __webpack_public_path__ + "img/kenyan-flag.7692ab90.svg";